/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ImageNoteUploadRequest } from '../models/image-note-upload-request';
@Injectable({
  providedIn: 'root',
})
class UploadService extends __BaseService {
  static readonly uploadCreatePath = '/upload';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  uploadCreateResponse(data: ImageNoteUploadRequest): __Observable<__StrictHttpResponse<ImageNoteUploadRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/upload`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ImageNoteUploadRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  uploadCreate(data: ImageNoteUploadRequest): __Observable<ImageNoteUploadRequest> {
    return this.uploadCreateResponse(data).pipe(
      __map(_r => _r.body as ImageNoteUploadRequest)
    );
  }
}

module UploadService {
}

export { UploadService }
